import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { UserService } from '../user-services/user.service';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url;
    return this.checkUserLogin(next, url);
  }

  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
    if (this.userService.isLoggedIn()) {
      const userRole = this.userService.getUserRole();
      // if (userRole && route?.data?.['role']?.length && route?.data?.['role'].indexOf(userRole.toUpperCase()) === -1) {
      //   console.log('You dont have access to this page')
      //   this.router.navigate(['/']);
      //   return false;
      // }
      // if (route.data['role'] && route.data['role'].indexOf(userRole) === -1) {
      //   this.router.navigate(['/']);
      //   return false;
      // }
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
